export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/DesktopHeroVideo-eb0e9e956288e9866746d50beca35b6c.mp4";